import React from 'react';


export class InNavbar extends React.Component<{$id:string,width?:any,overlayBody?:boolean,collapsible?:boolean}>{
    render(){
        return this.props.children || null;
    }
}